import * as React from "react";

class ButtonLText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonL-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 214.06 82.57"
      >
        <path
          fill="#fcfaee"
          d="M87.17,40.35c-.17.32-.35.62-.53.94H97.38V52.7H94.63v-.82H86.32v.82H83.7V45.15a17.91,17.91,0,0,1-3.54,2.75,15.72,15.72,0,0,0-1.72-2.2A15.32,15.32,0,0,0,84,40.35H79.15V38.19h6c.16-.32.3-.67.44-1H80.76V35.13h5.6a10,10,0,0,0,.25-1c-1.9.07-3.81.09-5.6.07a7.24,7.24,0,0,0-.5-2,115,115,0,0,0,16.09-.92l1.61,2a78,78,0,0,1-8.59.82c-.09.37-.2.74-.32,1.1h9V37.2H88.57c-.12.32-.26.67-.39,1H99.54v2.16Zm7.46,3H86.32v1h8.31Zm0,2.68H86.32v1h8.31Zm0,3.77V48.75H86.32v1.06Z"
        />
        <path
          fill="#fcfaee"
          d="M113.57,45.45a7.58,7.58,0,0,1-1.68,3.19c3,1,6.76,1.08,11.42,1a6.55,6.55,0,0,0-1.17,2.71c-5-.11-9.21-.46-12.5-1.9a20.77,20.77,0,0,1-6.22,2.16,13,13,0,0,0-1.65-2.44A22.23,22.23,0,0,0,107,48.87a11,11,0,0,1-2.37-2.57l2.09-.85h-2.43V36H111V34.65h-8.79V32.22h20.12v2.43h-8.45V36h7v9.44Zm-6.75-5.77H111V38.21h-4.22Zm0,3.54H111c0-.25,0-.51,0-.76v-.73h-4.22Zm.23,2.23a8.73,8.73,0,0,0,2.23,2,5.13,5.13,0,0,0,1.33-2Zm11.18-3.72h-4.31v.75a6.27,6.27,0,0,1,0,.74h4.34Zm-4.31-3.52v1.47h4.31V38.21Z"
        />
        <path
          fill="#fcfaee"
          d="M145.67,42.46c-3.24,7-10.77,9.39-19.52,10.22a11,11,0,0,0-1.1-2.64A37.49,37.49,0,0,0,135,48.22c-.64-.66-1.56-1.44-2.38-2.13a25.24,25.24,0,0,1-3,1.26A8.58,8.58,0,0,0,128,45.24c4.73-1.47,7.9-3.72,9.64-6l3,.69c-.45.53-.89,1-1.4,1.54h4.11l.51-.14Zm-3-8.45c-3,5.28-9.48,8.13-16.1,9.37A9.9,9.9,0,0,0,125.28,41a31.6,31.6,0,0,0,6.77-1.75,27.3,27.3,0,0,0-2.25-2.06c-.66.36-1.35.71-2.09,1a8.23,8.23,0,0,0-1.86-1.95,19.75,19.75,0,0,0,8-5.12l2.94.68c-.39.42-.8.83-1.24,1.25h4.85l.48-.12Zm-10.06,1.45c-.2.16-.43.29-.66.46a17.8,17.8,0,0,1,2.59,2.22,15.36,15.36,0,0,0,3.79-2.68Zm3.7,8.47-1.33.9a21.17,21.17,0,0,1,2.68,2.27,12.26,12.26,0,0,0,3.86-3.17Z"
        />
        <path
          fill="#fcfaee"
          d="M150.1,48.59a2.39,2.39,0,1,1,2.39,2.25A2.25,2.25,0,0,1,150.1,48.59Zm.39-11.71-.09-3.42h4.2l-.11,3.42-.81,7.85h-2.36Z"
        />
      </svg>
    );
  }
}

export default ButtonLText;



// WEBPACK FOOTER //
// ./src/submitFear/components/ButtonLText.tsx